import moment from 'moment';
export var action = {
  data() {
    return {

    }
  },
  methods: {
    foreignKeyAction(type) {
      return type == 'foreign';
    },

    selectAction(args /*types, method, action, preview, position*/) {
      const { types, method, action, preview, position, data } = args;
      const okSourceMethod =
        this.emptyString(action.sourceMethods) ||
        action.sourceMethods.split(",").includes(method);
      const okType =
        types.includes('general')
          ? action.type == null || types.includes(action.type)
          : types.includes(action.type);
      const okPreview =
        preview != null
          ? action.preview == null
            ? !preview
            : action.preview == preview
          : true;

      const global = {
        now: moment().format("llll"),
        nowFormatted: moment().format("YYYY-MM-DD"),
        method: this.transactionMethod,
        moment: moment,
        applicationName: this.applicationName,
        language: this.customLanguage,
      };

      const okAccess =
        action.accessFormula &&
          data &&
          Object.keys(data).length > 0
          ? eval(action.accessFormula, data, global)
          : true;
      const okPosition = action.position == position;
      return okSourceMethod && okType && okPreview && okPosition && okAccess;
    },

    customSelectActions(args /*actions, types, method, preview, position*/) {
      const { actions } = args;
      let result = [];
      if (actions) {
        actions.forEach((action, index) => {
          let nargs = args;
          nargs.action = action;
          if (this.selectAction(nargs)) {
            let output = action;
            output.oriIndex = index;
            result.push(output);
          }
        });
      }
      return result;
    },

    selectActions(args /*actions, types, method, preview, position*/) {
      const { preview } = args;
      let nargs = args;
      nargs.preview = null;
      let result = this.customSelectActions(nargs);
      if (result.length > 1) {
        nargs.preview = preview;
        result = this.customSelectActions(nargs);
      }
      return result;
    },

    selectOthers(args /*actions, types, method, position*/) {
      let nargs = args;
      nargs.preview = null;
      let all = this.customSelectActions(nargs);
      if (all.length > 1) {
        nargs.preview = false;
        let others = this.customSelectActions(nargs);
        return others.length > 0;
      } else {
        return false;
      }
    },
  }
}